module.exports = __webpack_public_path__ + "static/slider4-min-1355f522011fa4e1c636a8cd6c6af1a9.jpg";